import {
  STORE_SELECTED_EDI_RECORDS,
  CLEAR_SELECTED_EDI_RECORDS,
} from "../actionTypes";
const intialState = {
  selectedRow: {},
};

const rowSelectedReducer = (state = intialState, action) => {
  switch (action.type) {
    case STORE_SELECTED_EDI_RECORDS:
      return {
        ...state,
        selectedRow: action.payload,
      };
    case CLEAR_SELECTED_EDI_RECORDS:
      return {
        selectedRow: {},
      };
    default:
      return state;
  }
};
export default rowSelectedReducer;
